import { Component, HostListener, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HttpClient } from "@angular/common/http";
import { LoadingService } from "../../../core/loader/loading.service";
import { NotificationService } from "../notification/notification.service";
import { DataType } from "./generic-input-modal.type";

@Component({
  selector: "app-generic-modal",
  templateUrl: "./generic-input-modal.component.html",
  styleUrls: ["./generic-input-modal.component.css"],
})
export class GenericInputModalComponent implements OnInit {
  currentValue = "";
  loading$ = this.loader.loading$;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataType,
    public dialogRef: MatDialogRef<GenericInputModalComponent>,
    private http: HttpClient,
    private loader: LoadingService,
    private notificationService: NotificationService,
  ) {}

  @HostListener("window:keyup.esc") onKeyUp(): void {
    this.dialogRef.close(false);
  }

  ngOnInit(): void {}

  clearField(): void {
    this.currentValue = "";
  }
}
